import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BaseComponent } from '~app/app/~shared/abstract-components/base.component';
import { SubscriptionStatusService } from '~app/app/~shared/services/subscription-status.service';

@Component({
  selector: 'user-subscription-creation-dialog',
  standalone: false,
  templateUrl: './user-subscription-creation-dialog.component.html',
  styleUrl: './user-subscription-creation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSubscriptionCreationDialogComponent extends BaseComponent {
  private _subscriptionStatusService = inject(SubscriptionStatusService);
  currentSubscription$ =
    this._subscriptionStatusService.getCurrentSubscription();
}
